<template>
  <transition name="fade">
    <div v-if="showBanner" class="w-full flex items-center justify-center fixed top-0 left-0 right-0 bg-[#FFE8CC] px-5 py-2 tracking-[.001em] z-10">
      <span class="text-[#CF8B49]">
        Start learning finance on
        <a class="text-[#9E5600] underline font-semibold" @click.prevent="openNestPage" href=" ">Cowrywise Kids</a>
      </span>

      <a href="" @click.prevent="hideBanner" class="absolute right-5">
        <CloseIcon class="text-[#9E5600]" />
      </a>
    </div>
  </transition>
</template>

<script setup lang="ts">
import CloseIcon from '@/assets/svgs/icons/close.svg'
import { useHelpers } from '@/composables/useHelpers'
import { useUserStore } from '@/stores/user'
import { storeToRefs } from 'pinia'
import { ref, watch } from 'vue'

const { user, isKiddiesAccount } = storeToRefs(useUserStore())
const { setCookie, getCookie, sleep } = useHelpers()

const showBanner = ref(false)

const showNestBanner = async () => {
  if (isKiddiesAccount.value) return

  const bannerCookie = getCookie('nestBannerHidden')
  if (bannerCookie) return

  await sleep(2000)
  showBanner.value = true
}

const hideBanner = () => {
  setCookie('nestBannerHidden', 'true', 7)
  showBanner.value = false
}

const openNestPage = () => {
  hideBanner()
  setTimeout(() => {
    window.open('https://kids.cowrywise.com?cw_kids_utm_source=yellow_cowries', '_blank')
  }, 100)
}

watch(
  user,
  (newValue, oldValue) => {
    if (!oldValue && newValue) {
      showNestBanner()
    }
  },
  {
    immediate: true
  }
)
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
